// The person's own preference beside the chat: the model they last chose, in
// the console's own browser storage, per workspace and solution (impire-hq
// 02-DESIGN/19-chat/01-the-chat-solution.md § the Chat panel; hq decision
// 0083 § 1). The threads are the solution's, read through its verbs; nothing
// of them is kept here. Pure over an injected Storage so that it is tested
// without a window.

/** Prefs are the person's own. */
export interface Prefs {
  /** The model the person last chose, by workload id. */
  model?: string;
}

/** Store is the subset of the DOM Storage the element uses. */
export interface Store {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

const PREFIX = "impire-console:chat";

/** scopeOf names where one solution's preference lives in one workspace. */
export function scopeOf(slug: string, solution: string): string {
  return `${slug}:${solution}`;
}

export function prefsKey(scope: string): string {
  return `${PREFIX}:${scope}:prefs`;
}

/** threadsKey is where an earlier console kept the threads in this browser; forgotten on open (hq decision 0083 § 7). */
export function threadsKey(scope: string): string {
  return `${PREFIX}:${scope}:threads`;
}

/** forgetThreads drops the threads an earlier console kept in this browser: the solution keeps them now. */
export function forgetThreads(store: Store, scope: string): void {
  store.removeItem(threadsKey(scope));
}

export function loadPrefs(store: Store, scope: string): Prefs {
  const raw = store.getItem(prefsKey(scope));
  if (raw === null) {
    return {};
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed === "object" && parsed !== null) {
      const model = (parsed as Record<string, unknown>).model;
      return typeof model === "string" && model !== "" ? { model } : {};
    }
  } catch {
    // a damaged value is no preference
  }
  return {};
}

export function savePrefs(store: Store, scope: string, p: Prefs): void {
  store.setItem(prefsKey(scope), JSON.stringify(p));
}
